import { collection, query, where, getDocs, limit } from "firebase/firestore/lite";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../db/banco";
import ICriarCampanha from "../../types/ICriarCampanha";
import { idInfluenciadorValido, linkBaseValido, montarLinkFinal } from "../../utils/redirecionamento";
import Dot from "../../assets/Dot";
import General from "../Error/General";

export default function Principal() {
  const { idCampanhaParametro, idInfluenciadorParametro } = useParams<{
    idCampanhaParametro: string;
    idInfluenciadorParametro: string;
  }>();

  const [linkFinal, setLinkFinal] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mensagemErro, setMensagemErro] = useState<string | null>(null);

  useEffect(() => {
    const obterLinkECriar = async () => {
      const campanhasCollectionRef = collection(db, "criarCampanha");
      // Sem um ID de influenciador válido não há como rastrear, então não redireciona
      if (!idCampanhaParametro || !idInfluenciadorValido(idInfluenciadorParametro)) {
        setMensagemErro(
          `O ID do influenciador "${idInfluenciadorParametro ?? ""}" é inválido: deve conter apenas números, com no mínimo 4 dígitos (ex.: 1025).`
        );
        setIsLoading(false);
        return;
      }

      try {
        const q = query(
          campanhasCollectionRef,
          where("codigoActionpay", "==", idCampanhaParametro),
          limit(1)
        );

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docData = querySnapshot.docs[0].data() as ICriarCampanha;
          const linkBase = (docData.linkActionpayBase ?? "").trim();

          // Só redireciona se o link base seguir o padrão da Actionpay:
          // endereço https terminando com o marcador "subaccount", onde entra o ID
          if (!linkBase) {
            console.error("Campanha sem linkActionpayBase cadastrado:", idCampanhaParametro);
            setMensagemErro(
              `A campanha "${idCampanhaParametro}" foi encontrada, mas está sem o link da Actionpay cadastrado. Avise o suporte para completar o cadastro.`
            );
          } else if (!linkBaseValido(linkBase)) {
            console.error("linkActionpayBase fora do padrão (deve ser https e terminar com 'subaccount'):", linkBase);
            setMensagemErro(
              `A campanha "${idCampanhaParametro}" foi encontrada, mas o link da Actionpay cadastrado está fora do padrão — ele precisa terminar com "subaccount" para receber o ID do influenciador. Avise o suporte para corrigir o cadastro.`
            );
          } else {
            setLinkFinal(montarLinkFinal(linkBase, idInfluenciadorParametro));
          }
        } else {
          console.error("Nenhuma campanha encontrada com o código:", idCampanhaParametro);
          setMensagemErro(
            `Nenhuma campanha foi encontrada com o código "${idCampanhaParametro}". Confira se o link foi copiado por completo.`
          );
        }
      } catch (error) {
        console.error("Erro ao buscar a campanha:", error);
        setMensagemErro(
          "Não foi possível consultar os dados da campanha agora. Verifique sua conexão com a internet e tente novamente."
        );
      } finally {
        setIsLoading(false);
      }
    };

    obterLinkECriar();
  }, [idCampanhaParametro, idInfluenciadorParametro]);

  // Efeito para o redirecionamento, que só é executado quando o link final estiver disponível
  useEffect(() => {
    if (linkFinal) {
      window.location.href = linkFinal;
    }
  }, [linkFinal]);

  // Se o link ainda não foi gerado e o carregamento está ativo, exibe o componente Dot
  if (isLoading && !linkFinal) {
    return <Dot />;
  }

  // Se o carregamento terminou e o link não foi gerado (erro), exibe uma mensagem
  if (!isLoading && !linkFinal) {
    return (
      <General mensagem={mensagemErro ?? undefined} />
    );
  }
  
  // O componente não renderiza nada após o redirecionamento
  return null;
}